module.exports = __webpack_public_path__ + "static/media/noun_vineyard_156400.fc6dd687.svg";